import './FooterBanner.scss';

import React from 'react';
import flagIcon from '@progymedia/sbi-web-englander/src/images/englander-icons/Flag-Icon.svg';
import pricesIcon from '@progymedia/sbi-web-englander/src/images/englander-icons/Receipt-Icon.svg';
import truckIcon from '@progymedia/sbi-web-englander/src/images/englander-icons/Truck-Icon.svg';
import { useTranslation } from 'react-i18next';

export default function FooterBanner(props: {
    image: any;
    text?: string;
    isCartPage?: boolean;
}) {
    const { image, text, isCartPage = false } = props;
    const { t } = useTranslation('pages');

    return (
        <div className='footer-banner'>
            {text && <span className='text'>{text}</span>}
            {isCartPage && (
                <div className='foreground-text'>
                    <div>
                        <img src={truckIcon} alt='' />
                        <span className='label'>{t('cart.free-shipping')}</span>
                    </div>
                    <div>
                        <img src={flagIcon} alt='' />
                        <span className='label'>{t('cart.made-america')}</span>
                    </div>
                    <div>
                        <img src={pricesIcon} alt='' />
                        <span className='label'>{t('cart.best-prices')}</span>
                    </div>
                </div>
            )}
            <img className='background' src={image} alt='' />
        </div>
    );
}
